"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeLibraryCriterionSchema = exports.saveLibraryCriterionSchema = void 0;
exports.libraryNameOf = libraryNameOf;
exports.criterionFromLibrary = criterionFromLibrary;
const zod_1 = require("zod");
const job_builder_1 = require("./job-builder");
const schemas_1 = require("./schemas");
// F5.25 — the library of screening criteria (ADR 0048, DECISIONS-LOG 2026-10-16 "Keyword search on Ranking"
// Q4). Only what someone saves goes in. A job takes a copy (non-negotiable #4): a new row with a new
// id, edited freely, never linked back.
/** A criterion as the builder sends it to be saved; the row's id is the job's and is not kept. */
exports.saveLibraryCriterionSchema = zod_1.z.object({ criterion: job_builder_1.builderCriterionSchema });
exports.removeLibraryCriterionSchema = schemas_1.versionedSchema;
/** The library's name check, so "Knows Tally" and "knows tally " are one entry. */
function libraryNameOf(label) {
    return label.trim().replace(/\s+/g, ' ').toLowerCase();
}
/** The job's own copy of a saved criterion: a fresh row id, and nothing pointing back. */
function criterionFromLibrary(saved, newId) {
    return {
        id: newId,
        label: saved.label,
        importance: saved.importance,
        kind: saved.kind,
        lookFor: [...saved.lookFor],
        partlyCounts: [...saved.partlyCounts],
        minLevel: saved.minLevel,
    };
}
//# sourceMappingURL=criteria-library.js.map